import { IUser } from '@sravni/types/lib/auth';

import { ICommentCreateBody, ICommentsListDecorated, ICommentsListQuery } from '../interfaces/reviews';
import { getAuthHeader } from '../utils/auth';

import ProxyClient from './clients/ProxyClient';

export const loadCommentsList = async ({ user, ...params }: ICommentsListQuery & { user?: IUser }) => {
  const { data } = await ProxyClient.get<ICommentsListDecorated>('/comments', { params, headers: getAuthHeader(user) });
  return data;
};

export const createComment = async (data: ICommentCreateBody) => {
  return await ProxyClient.post<number>(`/comments/create`, data);
};

export const updateComment = async (data: ICommentCreateBody) => {
  return await ProxyClient.put(`/comments/update`, data);
};
